// extracted by mini-css-extract-plugin
export default {"wrapper":"fy-z","viewport":"gy-z","container":"hy-z","slide":"iy-z"};